import app from '../../app.jsx'

export const getTermsAndConditions = async (teamId, ident) => {
  try {
    const { data } = await app.service('/api/team/pdftemplate')
      .find({
        query: {
          teamId: teamId,
          ident,
          active: true
        }
      })

    return data && data[0] ? data[0].termsAndCondition : ''
  } catch (err) {
    app.debug('pdfTemplateUtils: getTermsAndConditions Error', err)
    return ''
  }
}
